import {z} from 'zod'
import {parseObjOrErr} from './type'
import {isString} from 'remeda'
import {notNullOrEmpty} from './collection'

type Reader = AsyncIterable<string | Buffer> | Iterable<string>
export async function* streamLineReader(reader: Reader) {
  const decoder = new TextDecoder()
  let buffer = ''
  for await (const chunk of reader) {
    buffer += isString(chunk) ? chunk : decoder.decode(chunk)
    const lines = buffer.split('\n')
    buffer = lines.pop() ?? ''
    for (const line of lines) if (line.trim()) yield line
  }
  if (buffer.trim()) yield buffer
}

export async function* jsonlRead<T extends z.ZodObject<any>>(reader: Reader, schema: T) {
  for await (const line of streamLineReader(reader)) yield parseObjOrErr(schema, JSON.parse(line))
}

export const jsonlParse = <T extends z.ZodObject<any>>(text: string, schema: T) =>
  text
    .split('\n')
    .filter(notNullOrEmpty)
    .map(line => parseObjOrErr(schema, JSON.parse(line)))
